import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';

const RegistrarResoluciones = () => {
  const { idEnte, idResolucion } = useParams();
  const navigate = useNavigate();

  // edit es true SOLO si hay idResolucion
  const edit = Boolean(idResolucion);

  const [codResolucionEnte, setCodResolucionEnte] = useState('');
  const [fechaResolucionEnte, setFechaResolucionEnte] = useState('');
  const [tipoResolucionEnte, setTipoResolucionEnte] = useState('');
  const [observacionResolucionEnte, setObservacionResolucionEnte] = useState('');

  const cleanData = () => {
    setCodResolucionEnte('');
    setFechaResolucionEnte('');
    setTipoResolucionEnte('');
    setObservacionResolucionEnte('');
  };

  const getData = async () => {
    try {
      const { data } = await axios.get(`/api/resolucion/listid/${idResolucion}`);
      if (data?.ok) {
        const r = data.resolucionEnte;
        setCodResolucionEnte(r.codResolucionEnte ?? '');
        setFechaResolucionEnte(r.fechaResolucionEnte?.substring(0, 10) ?? '');
        setTipoResolucionEnte(r.tipoResolucionEnte ?? '');
        setObservacionResolucionEnte(r.observacionResolucionEnte ?? '');
      } else {
        console.error('Resolución no encontrada.');
      }
    } catch (error) {
      console.error('Error al obtener la resolución:', error);
    }
  };

  // Solo cargar datos si es edición
  useEffect(() => {
    if (edit) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit, idResolucion]);

  const saveResolucion = async () => {
  try {
    if (!idEnte) {
      Swal.fire({
        icon: 'error',
        title: 'Falta el Ente',
        text: 'No se recibió el id del EnteConformador en la URL.',
      });
      return;
    }

    // Validar numérico antes de enviar
    if (!codResolucionEnte || isNaN(Number(codResolucionEnte))) {
      Swal.fire({
        icon: 'warning',
        title: 'Validación',
        text: 'El código de resolución debe ser un número válido.',
      });
      return;
    }

    const newResolucion = {
      codResolucionEnte: Number(codResolucionEnte), // 👈 lo convertimos aquí
      fechaResolucionEnte,
      tipoResolucionEnte,
      observacionResolucionEnte,
      enteObjectId: idEnte,
    };

    await axios.post('/api/resolucion/add', newResolucion);

    Swal.fire({
      icon: 'success',
      title: 'Resolución registrada exitosamente',
      timer: 1500,
      showConfirmButton: false,
    });

    cleanData();
    navigate(-1);
  } catch (error) {
    console.error('Error en saveResolucion:', error);

    // Mensaje más amigable
    let msg = 'Ocurrió un error inesperado al guardar la resolución.';
    if (error.response?.data?.message) {
      msg = error.response.data.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error al registrar la resolución',
      text: msg,
    });
  }
};

  const updateResolucion = async () => {
    try {
      const updatedData = {
        // Si el backend permite actualizar el código, inclúyelo también:
        codResolucionEnte,
        fechaResolucionEnte,
        tipoResolucionEnte,
        observacionResolucionEnte,
      };

      await axios.put(`/api/resolucion/update/${idResolucion}`, updatedData);

      Swal.fire({
        icon: 'success',
        title: 'Resolución actualizada exitosamente',
        timer: 1500,
        showConfirmButton: false,
      });

      navigate(-1);
    } catch (error) {
      console.error('Error al actualizar la resolución:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al actualizar la resolución',
        text: error.response?.data?.message || 'Ocurrió un error inesperado.',
      });
    }
  };

  const actions = async (e) => {
    e.preventDefault();
    edit ? updateResolucion() : saveResolucion();
  };

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
      <h1>{edit ? 'Editar Resolución' : 'Registrar Resolución'}</h1>

      <form onSubmit={actions}>
        <div className="container">
          <div className="row g-3 align-items-end justify-content-center">
            <div className="col-md-3">
              <label className="form-label">Código Resolución</label>
              <input
                type="text"
                className="form-control"
                value={codResolucionEnte}
                onChange={(e) => setCodResolucionEnte(e.target.value)}
                required
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Fecha de Resolución</label>
              <input
                type="date"
                className="form-control"
                value={fechaResolucionEnte}
                onChange={(e) => setFechaResolucionEnte(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Tipo de Resolución</label>
              <select
                className="form-select"
                value={tipoResolucionEnte}
                onChange={(e) => setTipoResolucionEnte(e.target.value)}
              >
                <option value="">Seleccione un tipo</option>
                <option value="Tecnica">Técnica</option>
                <option value="Academica">Académica</option>
              </select>
            </div>

            <div className="col-md-9">
              <label className="form-label">Observación</label>
              <input
                type="text"
                className="form-control"
                value={observacionResolucionEnte}
                onChange={(e) => setObservacionResolucionEnte(e.target.value)}
              />
            </div>
          </div>

          <div className="row container-flex mt-3 mb-3">
            <div className="col-md-6 d-flex justify-content-end">
              <button type="submit" className="btn btn-success w-100">
                {edit ? 'Actualizar' : 'Enviar'}
              </button>
            </div>
            <div className="col-md-6 d-flex justify-content-start">
              <button
                type="button"
                className="btn btn-danger w-100"
                onClick={() => {
                  cleanData();
                  navigate(-1);
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegistrarResoluciones;
